module.exports = __webpack_public_path__ + "static/media/bulk_planning_status.2766c464.csv";